module.exports = __webpack_public_path__ + "img/063-magician.e425b5b7.png";